module.exports = __webpack_public_path__ + "static/media/example-1.fe2d9492.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/PrinceHotel/example-1.jpg
// module id = 251
// module chunks = 0